import { render, staticRenderFns } from "./ReferrerPayHistory.vue?vue&type=template&id=5bf67567&scoped=true&"
import script from "./ReferrerPayHistory.vue?vue&type=script&lang=js&"
export * from "./ReferrerPayHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReferrerPayHistory.vue?vue&type=style&index=0&id=5bf67567&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf67567",
  null
  
)

export default component.exports